import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Chip, Tooltip } from '@mui/material';
import { apiService, EvidenceData } from '../services/api';

export const VERDICT_COLOR: Record<string, string> = {
  proven: '#22C55E', promising: '#38BDF8', no_edge: '#94A3B8', harmful: '#EF4444', too_early: '#F59E0B',
};

// Loaded once per session; the ledger changes only with a deploy
let cached: Promise<EvidenceData> | null = null;

/** The current page's verdicts from the evidence ledger (Feature 50), linking to the Evidence page. */
export default function EvidenceBadge({ path }: { path: string }) {
  const [data, setData] = useState<EvidenceData | null>(null);
  useEffect(() => {
    cached = cached ?? apiService.getEvidence();
    cached.then(setData).catch(() => { cached = null; });
  }, []);
  const entries = data?.entries.filter(e => e.pages.includes(path)) ?? [];
  if (!data || !entries.length) return null;
  const order = ['harmful', 'proven', 'promising', 'too_early', 'no_edge'];
  const counts = order.map(v => [v, entries.filter(e => e.verdict === v).length] as const).filter(([, n]) => n);
  const top = counts[0][0];
  return (
    <Tooltip title={<>{entries.map(e => <div key={e.id}>• {data.verdicts[e.verdict]}: {e.claim}</div>)}</>}>
      <Chip component={RouterLink} to="/evidence" clickable size="small"
        label={`Evidence: ${counts.map(([v, n]) => `${n} ${data.verdicts[v].toLowerCase()}`).join(' · ')}`}
        sx={{ mr: 2, bgcolor: `${VERDICT_COLOR[top]}33`, color: 'inherit', display: { xs: 'none', md: 'flex' } }} />
    </Tooltip>
  );
}
